<template>
    <div class="panel extras">
        <h4 class="mb-3 pb-3 border-bottom-light">Extras</h4>

        <ul v-if="extras.length > 0" class="table fs-normal bare">
            <li class="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom-light" v-for="(extra, index) in extras">
                <div class="title">
                    {{ extra.item.name }}

                    <span v-if="extra.isMandatory">(mandatory)</span>
                </div>

                <div class="price fs-small ml-auto mr-5 dark">
                    <div v-if="extra.priceIncluded">
                        (event price includes this extra)
                    </div>
                    <div v-else>
                        {{ extra.item.priceTotal }} &euro;
                    </div>
                </div>

                <calculator :object="extra.item" field="quantity" @mathDone="mathDone" :editable="editable"></calculator>
            </li>
        </ul>
        <div v-else>This product has no extras available.</div>

        <!--
        <div class="add d-flex align-items-center pointer" @click="addRow">
            <i class="ico-add add-circle color-1"></i> Add new
        </div>
        -->
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Calculator from './Calculator'

    export default {
        props: {
            editable: {
                type: Boolean,
                default: true,
            }
        },
        data: function() {
            return {
                form: {},
            }
        },
        created: function() {
            if (this.getClonedReservation) {
                this.form = JSON.parse(JSON.stringify(this.getClonedReservation));
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
            ]),
            extras: function() {
                return this.form.event.product.extras;
            }
        },
        methods: {
            ...mapActions([
                'updateClonedReservation'
            ]),
            addRow: function() {

            },
            mathDone: function(data) {
                let extra = this.extras.find(e => data.object.id === e.item.id);

                if (extra) {
                    extra.item.quantity = data.value;
                    extra.quantity = data.value;
                }

                this.$emit('updateExtras', this.extras);
            },
        },
        components: {
            Calculator
        }
    }
</script>



// WEBPACK FOOTER //
// Extras.vue?7105edb8